import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLinkClick = ({ data, event, }) => {
    const EVENT_DATA = {
        ...data,
        event,
    };
    const thorEvent = useTrackingEvent(EVENT_DATA);
    return () => thorEvent();
};
